import {
  getRandomInt,
  getRandomItemsFromArr,
} from 'src/replicant/utils/random';
import { createPrng } from '@play-co/replicant';
import { user } from 'src/StateObserver';
import { STREAK_EVENT_PLAYER_COUNT } from 'src/replicant/streakbattleroyale/streakbattleroyale.ruleset';
import { getStreakBattleRoyalePlayerCount } from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';
import { BOT_AVATARS } from 'src/replicant/bots/assets';

export function getStreakBattleRoyalePlayersAtMilestone(
  milestone: number,
  excludeSelf = false,
) {
  const state = user();
  const seed = state.streak!.joinedTimestamp;
  const prng = createPrng(`${seed}`);
  const avatarPool = [];

  // Fill the pool with enough avatars to cover the player count
  for (
    let amount = avatarPool.length;
    amount < STREAK_EVENT_PLAYER_COUNT;
    amount = avatarPool.length
  ) {
    avatarPool.push(...BOT_AVATARS);
  }

  const fakePool = avatarPool.map((photo, index) => ({
    id: `player-${index}`,
    photo,
  }));
  const poolCount = STREAK_EVENT_PLAYER_COUNT - 1;
  const fullList = getRandomItemsFromArr(fakePool, poolCount, prng);
  const fetchCount = getStreakBattleRoyalePlayerCount(state, milestone) - 1;
  const eliminatedCount = poolCount - fetchCount;
  const eliminated: { id: string; photo: string }[] = [];
  const listClone = fullList.slice();

  for (let index = 0; index < eliminatedCount; index++) {
    // Deterministically grab the same players that were eliminated before and the new ones
    const i = getRandomInt(0, listClone.length - 1, prng);
    eliminated.push(listClone[i]);
    listClone.splice(i, 1);
  }

  const remainingList = fullList.filter(
    (player) => !eliminated.includes(player),
  );

  if (excludeSelf) return remainingList;

  const id = state.id;
  const photo = state.publicProfile?.photo ?? state.profile?.photo;
  const self = { id, photo };

  return [self, ...remainingList];
}
